module.exports = __webpack_public_path__ + "img/icon_manager.8ccea925.png";